/**
 * Custom Gateway (g3d-app) button fallback
 * When product has #custom-gateway-info (smartlink), the theme shows "Please wait loading"
 * and waits for postMessage from the app. On mobile the message often never fires.
 * This script forces the button to "Personalise / Buy" after a timeout so it stays usable.
 *
 * Config comes from product description: <script type="application/json" id="custom-gateway-info">
 * {"type":"smartlink","desktop_url":"https://g3d-app.com/...?a2c=postMessage"}. The a2c=postMessage
 * means g3d-app will postMessage when user adds to cart; we must reply (addToCartDone) so Loading closes.
 *
 * Optional: theme can define window.__dreamlifeGatewayOnAddToCart(messageData, source, origin, done)
 * to handle add-to-cart from g3d-app; call done(success) when finished so we close modal and redirect.
 *
 * Add this to your theme (e.g. in theme.liquid before </body> or in a product section)
 * only on product pages.
 */
(function() {
  'use strict';

  var GATEWAY_SELECTOR = '#custom-gateway-info';
  var FALLBACK_MS = 4000;
  var TARGET_LABEL = 'Personalise / Buy';
  var GATEWAY_ORIGINS = ['https://g3d-app.com', 'https://www.g3d-app.com'];
  var OPEN_IN_SAME_WINDOW = false;
  // true = open personalization in iframe on same page so postMessage always works (stops Loading hang)
  var OPEN_IN_IFRAME = true;
  var MODAL_ID = 'dreamlife-gateway-modal';

  function getPersonalizeName() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = params.get('personalize_name') || params.get('name');
      if (fromUrl && fromUrl.trim().length >= 2) return fromUrl.trim();
      var fromStorage = localStorage.getItem('dreamlife_personalize_name');
      if (fromStorage && fromStorage.trim().length >= 2) return fromStorage.trim();
    } catch (e) {}
    return null;
  }

  function getGatewayUrl() {
    var el = document.querySelector(GATEWAY_SELECTOR);
    if (!el || !el.textContent) return null;
    try {
      var data = JSON.parse(el.textContent.trim());
      var url = data.mobile_url || data.desktop_url || data.url || null;
      if (!url) return null;
      var name = getPersonalizeName();
      if (name) {
        var sep = url.indexOf('?') !== -1 ? '&' : '?';
        url = url + sep + 'name=' + encodeURIComponent(name);
      }
      return url;
    } catch (e) { return null; }
  }

  function closeGatewayModal() {
    var el = document.getElementById(MODAL_ID);
    if (el) el.remove();
  }

  function openGatewayModal(url) {
    closeGatewayModal();
    var overlay = document.createElement('div');
    overlay.id = MODAL_ID;
    overlay.style.cssText = 'position:fixed;inset:0;z-index:999999;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;';
    var box = document.createElement('div');
    box.style.cssText = 'position:relative;width:100%;max-width:900px;height:90vh;max-height:700px;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.3);';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.style.cssText = 'position:absolute;top:12px;right:12px;z-index:10;width:36px;height:36px;border:none;background:rgba(0,0,0,0.5);color:#fff;font-size:20px;line-height:1;cursor:pointer;border-radius:50%;';
    closeBtn.textContent = '\u00D7';
    closeBtn.addEventListener('click', closeGatewayModal);
    var iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.style.cssText = 'width:100%;height:100%;border:none;';
    box.appendChild(closeBtn);
    box.appendChild(iframe);
    overlay.appendChild(box);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeGatewayModal(); });
    document.body.appendChild(overlay);
  }

  function isGatewayModalOpen() {
    return !!document.getElementById(MODAL_ID);
  }

  function isAllowedOrigin(origin) {
    if (origin && origin.indexOf('g3d-app.com') !== -1) return true;
    for (var i = 0; i < GATEWAY_ORIGINS.length; i++) {
      if (origin === GATEWAY_ORIGINS[i]) return true;
    }
    if ((!origin || origin === 'null') && isGatewayModalOpen()) return true;
    return false;
  }

  function normalizeCartItems(data) {
    var items = data.items;
    if (items && items.length) {
      return items.map(function(it) {
        return { id: it.id || it.variant_id || it.variantId, quantity: it.quantity || it.amount || 1 };
      });
    }
    if (data.id || data.variant_id || data.variantId) {
      return [{ id: data.id || data.variant_id || data.variantId, quantity: data.quantity || data.amount || 1 }];
    }
    return [];
  }

  function sendAddToCartDone(source, origin, success) {
    if (!source || !source.postMessage) return;
    var payload = { type: 'addToCartDone', success: success !== false };
    try {
      source.postMessage(payload, '*');
    } catch (e) {}
  }

  function findInObject(obj, keys) {
    if (!obj || typeof obj !== 'object') return null;
    for (var i = 0; i < keys.length; i++) {
      var v = obj[keys[i]];
      if (v !== undefined && v !== null) return v;
    }
    if (obj.data && typeof obj.data === 'object') return findInObject(obj.data, keys);
    if (obj.payload && typeof obj.payload === 'object') return findInObject(obj.payload, keys);
    return null;
  }

  function handleGatewayAddToCart(data, source, origin) {
    var url = data.url || data.cartUrl || data.redirectUrl || data.redirect ||
      findInObject(data, ['url', 'cartUrl', 'redirectUrl', 'redirect']);
    if (url && typeof url === 'string' && (url.indexOf('/cart') !== -1 || url.indexOf('checkout') !== -1)) {
      sendAddToCartDone(source, origin, true);
      closeGatewayModal();
      window.location.href = url.indexOf('http') === 0 ? url : (window.location.origin + (url.indexOf('/') === 0 ? url : '/' + url));
      return true;
    }
    var items = normalizeCartItems(data);
    if (items.length === 0 && data.data) items = normalizeCartItems(data.data);
    if (items.length === 0 && data.payload) items = normalizeCartItems(data.payload);
    if (items.length) {
      var cartAddUrl = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ? (window.Shopify.routes.root + 'cart/add.js') : '/cart/add.js';
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r) { return r.json(); }).then(function(res) {
        sendAddToCartDone(source, origin, !res.status || res.status === 200);
        closeGatewayModal();
        window.location.href = '/cart';
      }).catch(function() {
        sendAddToCartDone(source, origin, false);
        closeGatewayModal();
        window.location.href = '/cart';
      });
      return true;
    }
    return false;
  }

  function isReadyInitMessage(d) {
    if (!d || typeof d !== 'object') return false;
    var t = d.type || d.action || d.event || '';
    return t === 'ready' || t === 'init' || t === 'loaded' || t === 'ready';
  }

  function isHandshakeMessage(d) {
    if (!d || typeof d !== 'object') return false;
    if (d.h === '' && Object.keys(d).length <= 1) return true;
    if (d.h !== undefined && Object.keys(d).length === 1) return true;
    return false;
  }

  function looksLikeAddToCartMessage(d) {
    if (!d || typeof d !== 'object') return false;
    if (isReadyInitMessage(d)) return false;
    if (d.type === 'addToCart' || d.type === 'a2c' || d.type === 'add_to_cart' ||
        d.action === 'addToCart' || d.addToCart || d.event === 'addToCart' || d.message === 'addToCart' ||
        d.cartUrl || (d.url && (d.url.indexOf('/cart') !== -1 || d.url.indexOf('checkout') !== -1)) ||
        d.items || d.id || d.variant_id || d.variantId) return true;
    if (d.data && looksLikeAddToCartMessage(d.data)) return true;
    if (d.payload && looksLikeAddToCartMessage(d.payload)) return true;
    return false;
  }

  function setupGatewayMessageListener() {
    window.addEventListener('message', function(e) {
      if (isGatewayModalOpen()) {
        try { console.log('[Dream Life gateway] ANY message', e.origin, typeof e.data, Array.isArray(e.data) ? 'array len=' + e.data.length : '', e.data); } catch (err) {}
      }
      if (!document.querySelector(GATEWAY_SELECTOR)) return;
      if (!isAllowedOrigin(e.origin)) return;
      var d = e.data;
      if (d && typeof d === 'string') {
        try {
          d = JSON.parse(d);
        } catch (err) {
          try {
            var stripped = d.replace(/^!\s*_?\s*/, '');
            if (stripped !== d) d = JSON.parse(stripped);
            else return;
          } catch (err2) { return; }
        }
      }
      if (!d) return;
      if (typeof d === 'object' && !Array.isArray(d)) {
        if (window.DREAMLIFE_DEBUG_GATEWAY || isGatewayModalOpen()) {
          try { console.log('[Dream Life gateway] message from', e.origin, d); } catch (err) {}
        }
        if (isReadyInitMessage(d)) return;
        if (isHandshakeMessage(d)) return;
      } else if (Array.isArray(d) && d.length) {
        if (window.DREAMLIFE_DEBUG_GATEWAY || isGatewayModalOpen()) {
          try { console.log('[Dream Life gateway] message (array) from', e.origin, d); } catch (err) {}
        }
        var first = d[0];
        if (first === 'ready' || first === 'init' || first === 'loaded') return;
        d = typeof d[1] === 'object' ? d[1] : { _raw: d };
      } else {
        return;
      }
      var source = e.source;
      var origin = e.origin;
      var doneCallback = function(success) {
        sendAddToCartDone(source, origin, success !== false);
        closeGatewayModal();
        window.location.href = '/cart';
      };
      if (typeof window.__dreamlifeGatewayOnAddToCart === 'function') {
        try {
          var themeHandled = window.__dreamlifeGatewayOnAddToCart(d, source, origin, doneCallback);
          if (themeHandled === true) {
            e.stopImmediatePropagation();
            return;
          }
        } catch (err) {
          if (window.DREAMLIFE_DEBUG_GATEWAY) try { console.log('[Dream Life gateway] theme handler error', err); } catch (e2) {}
        }
      }
      sendAddToCartDone(source, origin, true);
      var handled = handleGatewayAddToCart(d, source, origin);
      if (handled) {
        e.stopImmediatePropagation();
      } else {
        closeGatewayModal();
        window.location.href = '/cart';
      }
    }, true);
  }

  function getAddToCartButton() {
    var btn = document.querySelector('button[data-add-to-cart]');
    if (btn) return btn;
    var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product-form form');
    if (form) {
      btn = form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
      if (btn) return btn;
    }
    var buttons = document.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var t = (b.textContent || b.innerText || '').toLowerCase();
      if (t.indexOf('add to cart') !== -1 || t.indexOf('loading') !== -1 || t.indexOf('please wait') !== -1 || t.indexOf('personalise') !== -1) {
        return b;
      }
    }
    return null;
  }

  function isStillLoading(btn) {
    if (!btn || btn.disabled) return true;
    var t = (btn.textContent || btn.innerText || '').toLowerCase();
    return t.indexOf('loading') !== -1 || t.indexOf('please wait') !== -1;
  }

  function setButtonReady(btn) {
    if (!btn) return;
    btn.textContent = TARGET_LABEL;
    btn.disabled = false;
    btn.removeAttribute('disabled');
    btn.setAttribute('aria-disabled', 'false');
    btn.removeAttribute('aria-busy');
    btn.setAttribute('tabindex', '0');
    btn.style.pointerEvents = 'auto';
    btn.style.cursor = 'pointer';
    btn.style.opacity = '1';
    btn.classList.remove('loading', 'disabled', 'btn--loading', 'button--loading');
    var span = btn.querySelector('.button-text, .btn__text, [data-button-label]');
    if (span) span.textContent = TARGET_LABEL;
    var parent = btn.closest('form') || btn.parentElement;
    if (parent) {
      parent.style.pointerEvents = 'auto';
      parent.classList.remove('loading', 'disabled');
    }
    if (btn.getAttribute('data-gateway-fallback') !== '1') {
      btn.setAttribute('data-gateway-fallback', '1');
      btn.addEventListener('click', function(e) {
        var url = getGatewayUrl();
        if (url) {
          e.preventDefault();
          e.stopPropagation();
          if (OPEN_IN_IFRAME) {
            openGatewayModal(url);
          } else if (OPEN_IN_SAME_WINDOW) {
            window.location.href = url;
          } else {
            window.open(url, '_blank', 'noopener');
          }
        }
      }, true);
    }
  }

  function runFallback() {
    if (!document.querySelector(GATEWAY_SELECTOR)) return;
    var btn = getAddToCartButton();
    if (!btn) return;
    var isProductBtn = btn.hasAttribute('data-add-to-cart');
    var needsEnable = isProductBtn || isStillLoading(btn) || btn.disabled || btn.getAttribute('aria-disabled') === 'true';
    if (needsEnable) {
      setButtonReady(btn);
    }
    if (btn.getAttribute('data-gateway-fallback') === '1' && (btn.disabled || btn.style.pointerEvents === 'none')) {
      setButtonReady(btn);
    }
  }

  function init() {
    if (!document.querySelector(GATEWAY_SELECTOR)) return;
    setupGatewayMessageListener();
    setTimeout(runFallback, 1000);
    setTimeout(runFallback, 2000);
    setTimeout(runFallback, FALLBACK_MS);
    setTimeout(runFallback, 6000);
    var checkCount = 0;
    var interval = setInterval(function() {
      runFallback();
      checkCount++;
      if (checkCount >= 6) clearInterval(interval);
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
